/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {getRegisteredUrl} from '../../../config/registered-urls';

const TRANSLATE_EXPR = /^\{\{\s*['"]([^'"]+)['"]\s*\|\s*translate\s*\}\}$/;

export function resolveStateTitleText(
  dataProperty: any,
  interpolateContext: any,
  translateInstant: (key: string) => string,
  interpolate: (template: string) => (context: any) => string
): string {
  if (!dataProperty) {
    return '';
  }
  if (typeof dataProperty === 'string') {
    const translateMatch = dataProperty.match(TRANSLATE_EXPR);
    if (translateMatch) {
      return translateInstant(translateMatch[1]);
    }
    // Plain translation keys (no {{ }}) — ngx returns the key when missing,
    // which is correct for literal English titles too.
    if (dataProperty.indexOf('{{') === -1) {
      return translateInstant(dataProperty);
    }
  }
  return interpolate(dataProperty)(interpolateContext);
}

export function buildStateTitle(options: {
  currentState: any;
  dataPropertyPath: string;
  prefix?: string;
  suffix?: string;
  separator?: string;
  hideSuffix?: boolean;
  window: any;
  getNetworkTranslations: (title: string) => string | null | undefined;
  translateInstant: (key: string) => string;
  interpolate: (template: string) => (context: any) => string;
}): string {
  const separator = options.separator || ' - ';
  const dataProperty = _.get(options.currentState, options.dataPropertyPath, '');
  const interpolateContext = _.get(options.currentState, ['locals', 'globals'], options.currentState);
  const title = resolveStateTitleText(
    dataProperty,
    interpolateContext,
    options.translateInstant,
    options.interpolate
  );
  const processedTitle = options.getNetworkTranslations(title) || title;
  const objectName = _.get(options.currentState, ['locals', 'title@app', 'model', 'name']);
  const regUrl = getRegisteredUrl(options.window);
  let suffix = _.get(regUrl, 'pageTitle');
  suffix = (options.hideSuffix || !suffix) ? options.suffix : suffix;
  return _.compact([options.prefix, objectName, processedTitle, suffix]).join(separator);
}
